import { FETCH_STEEL_PSEUDOGROUPS } from '../../actions';

export default (state = [], action) => {
	switch (action.type) {
		case FETCH_STEEL_PSEUDOGROUPS:
			return action.payload;
		default:
			return state;
	}
};
